module.exports = "pegasus_template/assets/themecapture1/small/bg0.png";